export default "__VITE_ASSET__CifAUK60__"